import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportClientError } from '@posilka/client/api/report-error';
import i18n from '@/i18n';

interface State {
  error: Error | null;
}

/** Render xatosida oq ekran o'rniga tushunarli xabar va qayta yuklash (SPEC §11: xato holati). */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[posilka] render error', error, info.componentStack);
    reportClientError('miniapp', error);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-4 p-6 text-center">
        <span className="grid h-20 w-20 place-items-center rounded-3xl bg-surface-2 text-4xl">
          😕
        </span>
        <p className="text-base">{i18n.t('common.error')}</p>
        <p className="max-w-xs text-xs break-words text-hint">{this.state.error.message}</p>
        <button type="button" className="btn-primary" onClick={() => window.location.reload()}>
          {i18n.t('common.reload')}
        </button>
      </div>
    );
  }
}
